import { useUserPermissions } from '@/hooks/useUserPermissions';
import { CUSTOMER_SERVICE_BLOCKED_EMAILS } from '@/constants/sidebarAccess';

/**
 * Bloqueio explicito de acesso ao Atendimento por e-mail.
 * Usa useUserPermissions para respeitar impersonation.
 */
export function useCanAccessCustomerService() {
  const { permissions, isLoading } = useUserPermissions();
  const email = (permissions?.email || '').toLowerCase();
  const blocked = !!email && (CUSTOMER_SERVICE_BLOCKED_EMAILS as readonly string[]).includes(email);

  return { canAccess: !blocked, isLoading };
}
